import { render } from "./loginPage.vue?vue&type=template&id=664b14e0"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/www.usevia.cn/fileManage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__